/* SEATZONE B2B repositioning — v2 (2026-10-11)
   旧版（v1 · 2026-10-02，QUOTE-ONLY 时代）在每个 PDP 无条件注入 "Request a Quote"
   并给 body 加 szp-b2b 降级加购按钮。buy-buttons.liquid v3（双模式：DTC 真加购 +
   B2B 询价，按变体判定）上线后，本脚本只对【没有】双模式购买盒的遗留模板生效，
   正常商品页一律不注入、不降级。
   回滚：恢复 v1（本机备份 tmp/ask1011/LIVE__assets__szp-b2b.js）。 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  ready(function () {
    /* buy-buttons v3 双模式购买盒存在 → 不注入、不加 body 类 */
    if (document.querySelector('[data-szp-buy]')) return;
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons || buttons.querySelector('.szp-quote-btn')) return;
    var a = document.createElement('a');
    a.className = 'button button--full-width button--primary szp-quote-btn';
    a.href = '/pages/request-a-quote';
    a.textContent = 'Request a Quote';
    buttons.parentNode.insertBefore(a, buttons);
    document.body.classList.add('szp-b2b');
  });
})();
